module.exports = __webpack_public_path__ + "img/statistics.ba7bb6ce.svg";